
import { Vue, Component, Emit, Ref, Prop, Watch } from 'vue-property-decorator'
import Loader from '@mg/web-components/Atoms/Loader'

@Component({ components: { Loader } })
export default class LazyComponent extends Vue {
  @Ref('lazyContent') readonly lazyContent!: HTMLButtonElement
  @Prop(Boolean) renderBot: boolean
  @Prop({ default: true, type: Boolean }) enabledLazy: boolean
  @Prop({ default: false, type: Boolean }) hideLoader: boolean
  @Prop({ default: 0, type: Number }) minHeight: number
  @Prop({ default: 0, type: Number }) loadedMinHeight: number
  @Prop({ default: 0, type: Number }) paddingBottom: number
  @Prop({ default: 0, type: Number }) marginLoad: number
  @Prop({ default: 0, type: Number }) topLoader: number
  observer: IntersectionObserver
  visibleElement = false
  enabledLazyInit = false

  get style() {
    if (this.isVisible) {
      return this.loadedMinHeight
        ? { minHeight: `${this.loadedMinHeight}px` }
        : {}
    }

    return this.paddingBottom && { paddingBottom: `${this.paddingBottom}px` }
  }

  get styleLoader() {
    return this.minHeight && { minHeight: `${this.minHeight}px` }
  }

  get isVisible() {
    if (this.$shopConfig.isBot || this.visibleElement) {
      return true
    }

    return !this.enabledLazyInit
  }

  @Watch('isVisible', { immediate: true })
  @Emit()
  onVisibilityChange(newVal: boolean) {
    return newVal
  }

  created() {
    this.enabledLazyInit = this.enabledLazy
  }

  mounted() {
    if (!process.client || this.$shopConfig.isBot) {
      return
    }

    const onIntersection = (entries: IntersectionObserverEntry[]) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.visibleElement = true
        }
      }
    }

    this.observer = new IntersectionObserver(onIntersection, {
      rootMargin: `${this.marginLoad}px`,
      threshold: 0,
    })
    if (this.lazyContent) {
      this.observer.observe(this.lazyContent)
    }
  }

  destroy() {
    this.observer.unobserve(this.lazyContent)
  }
}
